<template>
  <div>
    <div class="position-relative dinA4">
      <img :src="require('@/assets/additional-header.png')" class="page__header" />
      <div class="page__container">
        <table class="full-width mt-0">
          <tr class="primary-background">
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1">
              SERVICIOS INCLUIDOS
            </th>
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1"></th>
          </tr>
          <tr>
            <td class="body-2">Recogida y entrega a domicilio.</td>
            <td class="body-2 text-center">Incluido</td>
          </tr>
          <tr class="mb-0 mt-0 pb-0 pt-0">
            <td class="body-2">
              Cobertura por siniestro: Indemnización conforme a la Ley 15/2009 CTTM art. 57.
            </td>
            <td class="body-2 text-center">Incluido</td>
          </tr>
          <tr>
            <td class="body-2">Incluye hasta 2 intentos de entrega (+ un tercer intento si hay solución por parte del cliente o destinatario).</td>
            <td class="body-2 text-center">Incluido</td>
          </tr>
        </table>
        <table class="full-width table-highlight  body-2">
          <tr class=" mb-0">
            <td class="no-margins">
              Notificaciones
            </td>
          </tr>
          <tr class="no-margins my-0">
            <td class="no-margins">
              <ul>
                <li>
                  Los envíos que dispongan de email se beneficiarán GRATIS de la notificación de:
                  <ul>
                    <li>
                      Entrega Prevista: informamos un día antes al destinatario de la fecha prevista
                      de entrega.
                    </li>
                    <li>
                      Entrega Hoy: informamos al destinatario el mismo día de reparto de su envío.
                    </li>
                    <li>Entregado: informamos al destinatario que su envío ha sido entregado.</li>
                  </ul>
                </li>
              </ul>
            </td>
            <td class="body-2 body-2--bold text-right no-margins">Incluido</td>
          </tr>
          <tr class="my-0 no-margins">
            <td class="no-margins">
              <ul>
                <li>
                  Además, si su envío dispone de email y/o teléfono móvil se beneficiarán GRATIS de
                  la notificación de incidencia en la entrega, en caso de:
                  <ul>
                    <li>
                      Si el destinatario está ausente o no responde.
                    </li>
                    <li>
                      Si la dirección de entrega es incorrecta.
                    </li>
                  </ul>
                </li>
              </ul>

              Dando la opción al destinatario para recoger su envío en uno de nuestros más de
              20.000 puntos Collectt Express de conveniencia en España y Portugal <u>sin coste adicional.</u>
            </td>
            <td class="body-2 body-2--bold text-right no-margins">Incluido</td>
          </tr>
        </table>
        <table class="full-width body-2">
          <tr>
            <td class="body-2">Gestión proactiva de localización al destinatario</td>
            <td class="body-2 text-right">Incluido</td>
          </tr>
        </table>

        <table class="full-width mt-0 additional-services-table">
          <tr class="primary-background">
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1">
              SERVICIOS COMPLEMENTARIOS
            </th>
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1" />
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('SEG_DECLARADO') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('SEG_DECLARADO').value }}% (min
              {{ getAdditionalServiceById('SEG_DECLARADO').minValue
              }}<span class="euro-symbol">€</span>)
            </td>
          </tr>
          <tr>
            <td class="body-2" data-cy="kmEmision">
              {{ $t('OUTSKIRTS_KM') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('KM_EXTRARADIO').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('SATURDAY_DELIVERY') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('ENTREGA_SABADO').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <!-- <tr>
            <td class="body-2">
              {{ $t('FINAL_MANAGE') }}
            </td>
            <td nowrap class="body-2 text-center">
              A cotizar
            </td>
          </tr> -->
          <!-- <tr>
            <td class="body-2">
              {{ $t('ANT_COMMISSION') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('ANT_COMISION').value }}% (min
              {{ getAdditionalServiceById('ANT_COMISION').minValue
              }}<span class="euro-symbol">€</span>)
            </td>
          </tr> -->
          <tr>
            <td class="body-2">
              {{ $t('REFUND_2024') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('REEMBOLSO').value }}% (min
              {{ getAdditionalServiceById('REEMBOLSO').minValue
              }}<span class="euro-symbol">€</span>)
            </td>
          </tr>
          <!-- <tr>
            <td class="body-2">
              {{ $t('CTT_CARD') }} (1)
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('TARJETA_CTT').value }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('GROUPED_RETURN') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('DEV_AGRUPADA').value }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('DEST_PRINTING') }} (2)
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('IMPRESION_DESTINO').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('ADIT_PRINTING') }} (2)
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('IMPRESION_ADIC').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr> -->
          <tr v-if="this.getAdditionalServiceById('OTP').value !== undefined">
            <td class="body-2">
              {{ $t('OTP_TEXT') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('OTP').value) === 0">
                {{ $t('NOT_INCLUDED') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('OTP').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('DNI_VALIDATION') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('VALIDA_DNI').value }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('SCAN_DELIVERY_NOTE') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('ALB_ESCANEADO').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('SMS') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('SMS').value }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('GRANDES_SUPERFICIES') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('GRANDES_SUPERFICIES').value }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <!-- <tr>
            <td class="body-2">
              {{ $t('DGR') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('DGR').value }}<span class="euro-symbol">€</span>
            </td>
          </tr> -->
          <!-- <tr>
            <td class="body-2">
              {{ $t('REEX_CAN_INTER') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('REEX_CAN_INTER').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('REEX_CAN_KG') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('REEX_CAN_KG').value }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('REEX_CAN_INTER_48') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('REEX_CAN_INTER_48').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('REEX_CAN_INTER_48_MIN_50') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceByDesc('REEX_CAN_INTER_48_MIN_50').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('REEX_CAN_INTER_48_MAX_50') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceByDesc('REEX_CAN_INTER_48_MAX_50').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('ECOMMERCE_HIGH_VALUE') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('CAN_ECOMMERCE_ALTO_VALOR').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr> -->
          <!-- <tr>
            <td class="body-2">
              {{ $t('PORTER') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('MOZO').value }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('FOURTH_ATTEMPT') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('CUARTO_INTENTO').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('WAIT_TIME') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('TIEMPO_ESPERA').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('DIR_FURGO_500') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('DIR_FURGO_500').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('KM_FURGO_500') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('KM_FURGO_500').value }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('DIR_FURGO_1500') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('DIR_FURGO_1500').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('KM_FURGO_1500') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('KM_FURGO_1500').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('SM_FURGO_500') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('SM_FURGO_500').value }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('SM_FURGO_1500') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('SM_FURGO_1500').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr> -->
          <tr v-if="hasAdditionalService('ENTREGA_GRAN_SUPERFICIE')">
            <td class="body-2">
              {{ $t('ENTREGA_GRAN_SUPERFICIE') }}
              {{ $t('ENTREGA_GRAN_SUPERFICIE__PDF_ONLY') }}
            </td>
            <td nowrap class="body-2 text-center">
              {{ getAdditionalServiceById('ENTREGA_GRAN_SUPERFICIE').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <!-- <tr>
            <td class="body-2">
              {{ $t('EDP') }}
            </td>
            <td class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('EDP').value) === 0">
                {{ $t('NOT_INCLUDED') }}
              </template>
<template v-else>
                {{ getAdditionalServiceById('EDP').value }}<span class="euro-symbol">€</span>
              </template>
</td>
</tr> -->

        </table>
        <!-- <p class="body-2 mt-6 mb-0 justify-text">
          (1) <b>Tarjeta CTT PLUS:</b> El uso de la tarjeta CTT PLUS está indicado para clientes que
          cuentan con un equipo de personas (comerciales, mecánicos, asesores, abogados, peritos,
          etc.) que viajan constantemente y tengan la necesidad de solicitar un servicio en
          cualquiera de nuestras agencias CTT Express con cargo a su empresa.
        </p>
        <p class="body-2 mt-6 mb-0 justify-text">
          (2) Cualquier envío que conlleve la impresión de un documento en la oficina de origen o
          destino hasta 5 hojas o adicionales para su posterior recogida / entrega como si de un
          envío normal se tratara.
        </p> -->
      </div>

      <Footer logo :page="previousPages + 1" />
    </div>
  </div>
</template>

<script>
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2025/Footer'

export default {
  name: 'AdditionalServices',
  components: { Footer },
  data() {
    return {
      previousPages: 0,
    }
  },
  methods: {
    hasAdditionalService(id) {
      return Object.keys(this.$parent.getAdditionalServiceById(id)).length > 0
    },
    getAdditionalServiceById(id) {
      return this.$parent.getAdditionalServiceById(id)
    },
    getAdditionalServiceByDesc(desc) {
      return this.$parent.getAdditionalServiceByDesc(desc)
    },
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('AdditionalServices');
  },
}
</script>

<style>
.additional-services-table td {
  vertical-align: top;
}

.no-margins {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>
